/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! Funnel Alerts — viewer.
 *  /scan -> per-funnel findings (baseline vs recent) ; /feed -> persisted history ; POST /ack.
 *  Talks through the app's GS.api ({ok,status,data}). Deep-linkable via ?funnel=<id>.
 */
(function () {
  "use strict";
  try { (window.GS_BUILD = window.GS_BUILD || {})["funnel-alerts"] = "1.0.0"; } catch (e) {}
  if (window.__fnaWired) return; window.__fnaWired = 1;

  var root = document.querySelector('[data-fa="root"]');
  if (!root) return;
  function q(k) { return root.querySelector('[data-fa="' + k + '"]'); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function siteParam() { return "site=" + encodeURIComponent((window.GS && GS.site) || ""); }
  function num(n) { return (+n || 0).toLocaleString(); }
  function ready(fn) {
    var done = false; function go() { if (done) return; done = true; fn(); }
    document.addEventListener("gs:ready", go, { once: true });
    var n = 0, t = setInterval(function () { if (window.GS && GS.api && GS.site) { clearInterval(t); go(); } else if (++n > 200) clearInterval(t); }, 30);
    if (window.GS && GS.api && GS.site) go();
  }
  function post(path, body) { return GS.api(path + "?" + siteParam(), { method: "POST", body: JSON.stringify(body || {}) }); }
  function ago(iso) {
    if (!iso) return ""; var d = new Date(String(iso).replace(" ", "T") + "Z"), s = Math.max(0, (Date.now() - d.getTime()) / 1000);
    if (s < 3600) return Math.floor(s / 60) + "m ago"; if (s < 86400) return Math.floor(s / 3600) + "h ago"; return Math.floor(s / 86400) + "d ago";
  }
  var FOCUS = new URLSearchParams(location.search).get("funnel");

  function loadScan() {
    GS.api("/plugin/funnel-alerts/scan?" + siteParam()).then(function (r) {
      var d = (r && r.ok && r.data) || {}, res = q("results"), sum = q("summary");
      if (!d.funnels_scanned) { sum.hidden = true; res.innerHTML = '<div class="fa-empty">' + esc(d.note || TR('funnel.f2.no_funnels_to_monitor_yet')) + "</div>"; return; }
      sum.hidden = false;
      q("s-scanned").textContent = num(d.funnels_scanned);
      q("s-reg").textContent = num(d.alerting || 0);
      q("s-imp").textContent = num(d.improved || 0);
      q("s-stable").textContent = num(d.stable || 0);
      var results = d.results || [];
      if (FOCUS) results = results.filter(function (x) { return String(x.funnel_id) === String(FOCUS); });
      if (!results.length) { res.innerHTML = '<div class="fa-empty">'+TR('funnel.no_regressions_or_improvements_beyond_the_th')+'</div>'; return; }
      res.innerHTML = results.map(funnelCard).join("");
    });
  }

  function funnelCard(f) {
    var alerts = (f.alerts || []).map(function (a) {
      return '<div class="fa-alert"><span class="sv ' + esc(a.severity) + '">' + esc(a.severity) + '</span><span>' + esc(a.message) + "</span></div>";
    }).join("");
    var steps = "";
    if (f.baseline && f.recent && f.steps) {
      var leak = f.worst_step && f.worst_step.delta < 0 ? f.worst_step.step : null;
      steps = '<div class="fa-steps">' + f.steps.map(function (s) {
        var rb = (f.baseline.rates[s] != null ? f.baseline.rates[s] : 0), rr = (f.recent.rates[s] != null ? f.recent.rates[s] : 0);
        var isLeak = s === leak;
        return '<div class="fa-step' + (isLeak ? " leak" : "") + '"><span class="fa-step-k">' + esc(s) + "</span>" +
          '<span class="fa-step-bars"><span class="fa-bar base"><i style="width:' + Math.min(100, rb) + '%"></i></span>' +
          '<span class="fa-bar rec"><i style="width:' + Math.min(100, rr) + '%"></i></span></span>' +
          '<span class="fa-step-val">' + rb + "% &rarr; <b>" + rr + "%</b></span></div>";
      }).join("") +
        '<div class="fa-legend"><span><i class="lb"></i>baseline</span><span><i class="lr"></i>recent</span></div></div>';
    }
    return '<div class="fa-card ' + esc(f.status) + '">' +
      '<div class="fa-card-top"><span class="fa-fname">' + esc(f.name || ("Funnel #" + f.funnel_id)) + "</span>" +
      '<span class="fa-status ' + esc(f.status) + '">' + esc(f.status) + "</span></div>" +
      alerts + steps + "</div>";
  }

  function loadHistory() {
    GS.api("/plugin/funnel-alerts/feed?" + siteParam() + "&hours=168").then(function (r) {
      var d = (r && r.ok && r.data) || {}, host = q("history");
      if (!(d.alerts || []).length) { host.innerHTML = '<div class="fa-empty">No funnel alerts in the last 7 days.</div>'; return; }
      host.innerHTML = d.alerts.map(function (a) {
        return '<div class="fa-hrow' + (a.acknowledged ? " ackd" : "") + '"><span class="fa-hsev ' + esc(a.severity) + '"></span>' +
          '<span class="fa-hmsg" title="' + esc(a.message) + '"><b>' + esc(a.funnel_name || ("#" + a.funnel_id)) + "</b> — " + esc(a.message) + "</span>" +
          (a.fire_count > 1 ? '<span class="fa-hcount">&times;' + a.fire_count + "</span>" : "") +
          '<span class="fa-hcount">' + ago(a.last_fired_at) + "</span>" +
          (a.acknowledged ? "" : '<button class="fa-hack" data-ack="' + a.id + '">Ack</button>') + "</div>";
      }).join("");
      Array.prototype.forEach.call(host.querySelectorAll("[data-ack]"), function (b) {
        b.addEventListener("click", function () { post("/plugin/funnel-alerts/ack", { id: +b.getAttribute("data-ack") }).then(loadHistory); });
      });
    });
  }

  ready(function () {
    q("scan").addEventListener("click", function () { loadScan(); loadHistory(); });
    var aa = q("ackall"); if (aa) aa.addEventListener("click", function () { post("/plugin/funnel-alerts/ack", { all: true }).then(loadHistory); });
    loadScan(); loadHistory();
  });
})();
